import { actionTypes } from "./actions";

const initialState = {
  data: [],
  cnpj: [],
  cnpjLoader: false
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_WS_PARTNERS:
      return {
        ...state,
        data: payload,
      };
    case actionTypes.SET_CNPJ:
      return {
        ...state,
        cnpj: payload,
      };
    case actionTypes.CNPJ_LOADER:
      return {
        ...state,
        cnpjLoader: payload,
      };
      
    default:
      return {
        ...state,
      };
  }
};
